import React, { useEffect, useState } from 'react'
import { useDebounce } from '@node-space/hooks'
import { Box } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import NoSearchResults from 'components/NoSearchResults/NoSearchResults'
import { ActionListSkeletonLoader } from 'components/Skeletons/ActionListSkeletonLoader'
import { useCustomersQuery } from 'hooks/queries/Customers/useCustomersQuery'
import { CustomerResultsView } from './CustomerResultsView'
import { CustomersEmptyView } from './CustomersEmptyView'

export interface CustomersViewProps {
  searchQuery: string
  resetSearchQuery: () => void
}

const PAGE_SIZE = 10

export const CustomersView = ({ searchQuery, resetSearchQuery }: CustomersViewProps) => {
  const debouncedSearchTerm = useDebounce(searchQuery, 1000)
  const [page, setPage] = useState<number>(0)

  // TODO: handle paging
  const {
    data: { content: customersData } = {},
    isFetching,
    isError,
    refetch,
  } = useCustomersQuery(debouncedSearchTerm, PAGE_SIZE, page)

  useEffect(() => {
    refetch()
  }, [debouncedSearchTerm])

  if (isFetching) {
    return (
      <Box>
        <ActionListSkeletonLoader rows={PAGE_SIZE} />
      </Box>
    )
  }
  if (isError) {
    return <RequestErrorStatusCard onReload={refetch} />
  }
  if (customersData?.length) {
    return <CustomerResultsView customersData={customersData} />
  }
  if (debouncedSearchTerm) {
    return <NoSearchResults clearSearchCriteria={resetSearchQuery} />
  }
  return <CustomersEmptyView />
}
